import { IDefineCommand, IQuery } from 'core-ts-types';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { UpdateSectionSelectionCommand } from './update_section_selection_command';

export type RemoveSectionSelectionCommand = (sectionId: ISection['id']) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'removeSectionSelectionCommand',
    function removeSectionSelectionCommand(
      defineCommandORM: IDefineCommand,
      updateSectionSelectionsCommand: UpdateSectionSelectionCommand
    ) {
      'use strict';

      return defineCommandORM('removeSectionSelectionCommand', (deferred, sectionId: ISection['id']) => {
        if (!sectionId) {
          deferred.reject('Invalid section id');
          return;
        }
        updateSectionSelectionsCommand(sectionId, false).then(deferred.resolve);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_selections/commands/remove_section_selection_command.ts